export const getTimeRemaining = (time: number, timeAt: number) => {
  const diff = Math.round(new Date().getTime() / 1000 - timeAt / 1000);
  if (time > diff) {
    return time - diff;
  }
  return 0;
};
